/* Dynamic Plot code copyright 2015 (c) Tuva Labs Inc. */
/**
 *
 * created by jpatel, nganesan
 * CaseCard component
 * - lists attributes items, allows to drag on plot
 */

import React from 'react';

import AttributeListComponent from './AttributeListComponent.jsx';
import NewAttributeComponent from './attribute/NewAttributeComponent.jsx';
import AttributeDisplaySetting from './AttributeDisplaySetting.jsx';
import AttributeEditComponent from './attribute/AttributeEditComponent.jsx';
import RandomSampleComponent from './RandomSampleComponent.jsx';
import ModelFunctionsWrapper from './model-functions/ModelFunctionsWrapper.jsx';
import PlotSettingComponent from './PlotSettingComponent.jsx';
import AccessibilitySettingsComponent from './AccessibilitySettingsComponent.jsx';
import DynG from '../utils/Global';
import { Transition } from 'react-transition-group';

// Default animation properties
const _transtionDuration = 300;
const _defaultStyleForTransition = {
    transition: `all ${_transtionDuration}ms ease`,
    position: 'absolute',
    zIndex: 0
}
// To move cards right to left on open and left to right on close
const _transitionStyles = {
  entering: { left: 0 },
  entered:  { left: 0 },
  exiting:  { left: '100%' },
  exited:  { left: '100%' },
};
// To move attribute list card right to left on close and left to right on open
const _transitionStylesForAttribList = {
    entering: { right: 0 },
    entered:  { right: 0 },
    exiting:  { right: '100%' },
    exited:  { right: '100%' },
};

// import {Dyn, DragDropManager} from '../lib/dynDataSet/dynMiscellany';
// import mediator from '../lib/dynDataSet/mediatorUtil';

// List of card names
const CARDS = Object.freeze({
    ATTRIBUTE_LIST: 'ATTRIBUTE_LIST',
    ATTRIBUTE_EDIT: 'ATTRIBUTE_EDIT',
    ATTRIBUTE_ADD: 'ATTRIBUTE_ADD',
    SAMPLING: 'SAMPLING',
    MODEL_FUNCTIONS: 'MODEL_FUNCTIONS',
    PLOT_SETTINGS: 'PLOT_SETTINGS',
    ACCESSIBILITY_SETTINGS: 'ACCESSIBILITY_SETTINGS',
    ATTRIBUTE_SETTINGS: 'ATTRIBUTE_SETTINGS',
});

// Card Aria label description
const CARDS_ARIA_LABEL = Object.freeze({
    ATTRIBUTE_LIST: 'Case Card',
    ATTRIBUTE_EDIT: 'Attribute Settings Card',
    ATTRIBUTE_ADD: 'Add New Attribute Card',
    SAMPLING: 'Sampling Card',
    MODEL_FUNCTIONS: 'Modeling Card',
    PLOT_SETTINGS: 'Plot Settings Card',
    ACCESSIBILITY_SETTINGS: 'Accessibility Card',
    ATTRIBUTE_SETTINGS: 'Attribute Display Settings Card',
});

class CaseCardComponent extends React.Component {

    state = {
        eleToFocus: '',
        activeCard: CARDS.ATTRIBUTE_LIST,
        editingAttribute: undefined,
        // For case card/attribute list
        recordIndex: 0,
        attribs: [],
        onAxisArribsIds: [], // attributes used in plot TODO: fix spelling to 'onAxisAttribIds'
        selectedAttribID: '',
        filteredArribsIds: [], // TODO: fix spelling to 'filteredAttribIds'
    }

    // To create an attribute object which is compatible w/ CaseCard
    setBaseCase = () => {
        let Dyn = this.props.Dyn,
            newState = {
                attribs:[]
            };
        for(var i=1, numAttribs=Dyn.dataSet.getNumAttributes(); i<numAttribs; i++) {
            // Ignore the other datatypes
            if(this.props.dataType && Dyn.dataSet.attribs[i].getDataType() !== this.props.dataType) {
                continue;
            }
            var attr = {
                name: Dyn.dataSet.attribs[i].name || Dyn.dataSet.columnNames[i],
                columnName: Dyn.dataSet.columnNames[i],
                longName: Dyn.dataSet.attribs[i].longName,
                id: Dyn.dataSet.columnIds[i],
                isVisible: Dyn.dataSet.attribs[i].isVisible,
                //cases: Dyn.dataSet.attribs[i].originalCases,  //TODO: get case values from   attribs[i].caseValueToString( record_index )
                rawAttr: Dyn.dataSet.attribs[i]
            };
            newState.attribs.push(attr);
        }
        if( this.state.selectedAttribID && ! Dyn.dataSet.columnIds.includes( this.state.selectedAttribID )) {
            // clear selectedAttribID if attribute deleted
            newState.selectedAttribID = '';
        }
        // clear deleted attributes from 'on axis' and 'filtered' lists
        newState.filteredArribsIds = this.state.filteredArribsIds.filter( id => Dyn.dataSet.columnIds.includes( id ));
        newState.onAxisArribsIds = this.state.onAxisArribsIds.filter( id => Dyn.dataSet.columnIds.includes( id ));
        this.setState(newState );
    }

    displaySettingAttribute = ( e ) => {
        if(e) {
            e.stopPropagation();
        }
        this.openCard(CARDS.ATTRIBUTE_SETTINGS);
    }

    openModelFunctions = () => {
        this.openCard(CARDS.MODEL_FUNCTIONS);
    }

    closeModelFunctions = () => {
        this.openCard();
    }

    openPlotSettings = () => {
        this.openCard(CARDS.PLOT_SETTINGS);
    }

    closePlotSettings = () => {
        this.openCard();
    }

    openAccessibilitySettings = () => {
        this.openCard(CARDS.ACCESSIBILITY_SETTINGS);
    }

    closeAccessibilitySettings = () => {
        this.openCard();
    }

    // openStyleSettings = () => {
    //     if(this.state.isStyleSettings) {
    //         return;
    //     }
    //     if(!this.props.isOpen) {
    //         this.leftToggle(true);
    //     }
    //     // TODO: Find out is there any best solution to make reactjs understand about frequent state changes
    //     setTimeout(() => {
    //         this.setState({
    //             isStyleSettings: true
    //         });
    //     }, 10);

    //     // To highlight f(x) in toolbar
    //     if(this.props.onStyleSettingsVisibilityChange) {
    //         this.props.onStyleSettingsVisibilityChange(true);
    //     }
    // }

    // closeStyleSettings = () => {
    //     if( ! this.state.isStyleSettings) {
    //         return;
    //     }
    //     if(!this.props.isOpen) {
    //         this.leftToggle(true);
    //     }
    //     // TODO: Find out is there any best solution to make reactjs understand about frequent state changes
    //     setTimeout(() => {
    //         this.setState({
    //             isStyleSettings: false
    //         });
    //     }, 10);
    // }

    openRandomSample = () => {
        this.openCard(CARDS.SAMPLING);
    }

    closeRandomSample  = () => {
        this.openCard();
    }

    // Restore cardview from plotstate
    restore = (cardview) => {
        if(cardview.activecard === CARDS.ATTRIBUTE_EDIT) {
            let Dyn = this.props.Dyn;
            this.state.editingAttribute = Dyn.dataSet.getAttributeByID(cardview.metadata.attributeId);
            this.openCard(CARDS.ATTRIBUTE_EDIT);
        } else if(cardview.activecard === CARDS.SAMPLING) {
            // TODO: Set sampling related metadata
            this.openCard(CARDS.SAMPLING);
        } else {
            this.openCard(cardview.activecard);
        }
    }

    // Return current card state for plotstate
    save = () => {
        const activeCard = this.state.activeCard;
        // TODO: Remove this condition once the save/restore supported is added for sampling
        if(activeCard === CARDS.SAMPLING) {
            return;
        }
        // Return none when active card is attribute list
        if(activeCard !== CARDS.ATTRIBUTE_LIST) {
            const cardview = {
                activecard: activeCard
            };
            if(activeCard === CARDS.ATTRIBUTE_EDIT) {
                cardview.metadata = {
                    attributeId: this.state.editingAttribute.id
                }
            } else if(activeCard === CARDS.SAMPLING) {
                // TODO: Get sampling related metadata
            }
            return cardview;
        }
    }

    addOrEditAttribute = (attr) => {
        if(attr) {
            // The state will be refreshed with open card
            this.state.editingAttribute = attr;
            this.openCard(CARDS.ATTRIBUTE_EDIT);
        } else {
            // To open ATTRIBUTE_ADD card
            this.openCard(CARDS.ATTRIBUTE_ADD);
        }
    }

    reinstateCaseCard = (forceUpdate) => {
        this.openCard(undefined, forceUpdate);
    }

    // TODO: Clean this function
    leftToggle = (isOpen) => {
        this.props.onCaseCardToggled(isOpen);
    }

    // To highlight it in attribute list view
    setCasesSelected = (args) => {
        let Dyn = this.props.Dyn;
        var recordIndex = args.ids.length ? parseInt(args.ids[0]) : 0 ;

        // if its due to category selection from summaryview, or
        // legend area - ignore the message
        if ( args.ids.length > 1 && (args.isCategoryChange || args.isNumericRangeChange) )
            return;

        if ( recordIndex !== this.props.recordIndex ){
            this.setState({recordIndex: recordIndex});
        }
        // Don't mess with case card open/close when marquee select
        if((!this.props.isOpen) && !(!Dyn.plotView?.isInMarqueeSelect())) {
            this.leftToggle(true);
        }
    }

    // For case card
    setAddedAttribute = (args) => {
        var onAxisArribsIds = this.state.onAxisArribsIds;
        if(onAxisArribsIds.indexOf(args.id) === -1) {
            onAxisArribsIds.push(args.id)
            this.setState({onAxisArribsIds: onAxisArribsIds});
        }
    }

    // For case card
    setRemovedAttribute = (args) => {
        var onAxisArribsIds = this.state.onAxisArribsIds;
        if ( args ) {
            var index = onAxisArribsIds.indexOf(args.id);
            if(index >= -1) {
                onAxisArribsIds.splice(index, 1);
                this.setState({onAxisArribsIds: onAxisArribsIds});
            }
        }
    }

    /**
     * Case data added/removed/updated, which can include metadata and attributes added, removed, or updated.
     * @param args { AttributeValuesNotifier } -- flags and attribute IDs indicating what changed
     */
    setAttributeValues = (args) => {
        let Dyn = this.props.Dyn,
            newState = {},
            updated = false;
        if( args.addAttribute || args.deleteAttribute // add new attributes, remove deleted attributes
            || args.nameUpdate || args.descriptionUpdate) { // refresh attribute name + description
            this.setBaseCase();
            updated = true;
        }
        if( args.numCasesUpdate ) {
            let numCases = Dyn.dataSet.getNumCasesPreFilter(),
                recordIndex = Math.min( this.state.recordIndex, Math.max( 0, numCases-1 ));
            newState.recordIndex = recordIndex;
            this.setState( newState );
            updated = true;
        }
        if(( ! updated ) && (
            args.caseValueUpdate ||
            args.formulaUpdate ))
        {
            this.forceUpdate(); // redraw to show new case values (needed if no state changes so far)
        }
    }

    /**
     * Update the case card after a Dyn.Attribute's metadata has changed.
     * @param args {attributeID|dataType|sortOrder|categoryOrder} - details of what changed for optimization
     */
    setAttributeMetadata = (args) => {
        this.forceUpdate(); // redraw to show new case values (needed if no state changes so far)
    }

    // For case card
    removeCasesFiltered = (args) => {
        if(!args.categories && !args.numeric) {
            var filteredArribsIds = this.state.filteredArribsIds;
            var index = filteredArribsIds.indexOf(args.attributeID);
            if( index >=0 ) {
                filteredArribsIds.splice(index, 1);
                this.setState({filteredArribsIds: filteredArribsIds});
            }
        }
    }

    // Listen category filter changes from edit-attribute component
    // and update it to parent onAttributeCaseFilter listener
    // For case card
    onAttributeCaseFilter = (args) => {
        this.removeCasesFiltered(args);
        if(this.props.onAttributeCaseFilter) {
            this.props.onAttributeCaseFilter(args);
        }
    }

    // For case card
    setCasesFiltered = (args) => {
        let Dyn = this.props.Dyn;
        if( "resetAll" in args && args.resetAll ) {
            this.setState({filteredArribsIds: []});
        } else {
            // If individual attribute filter applied, update icon for filter
            var filter = Dyn.dataSet.caseFilter;
            for ( var i = 0; i < Dyn.dataSet.attribs.length; i++ ) {
                var casesFilteredByAttribute = filter.getNumCasesExcludedByAttribute(Dyn.dataSet.attribs[i].id);
                if ( casesFilteredByAttribute > 0 ) {
                    var attribute = Dyn.dataSet.attribs[i];
                    var filteredArribsIds = this.state.filteredArribsIds;
                    if(filteredArribsIds.indexOf(attribute.id) === -1) {
                        filteredArribsIds.push(attribute.id);
                        this.setState({filteredArribsIds: filteredArribsIds});
                    }
                }
            }
        }

        // TODO: Validate this implementation
        // when checking #681 this does not get called. We should enable, but also
        // need to protect attributeFilterComponent from round-trip calls when filter change
        // initiated by the panel, e.g. with a attributeFilterComponent.isInFilterStateChange flag
        // --CM 2021-05-31
        if(this.refs.attributeFilterComponent) {
            this.refs.attributeFilterComponent.updateCasesFiltered(args);
        }
    }

    // For case card
    setSelectedAttribute = (args) => {
        this.setState({selectedAttribID: args.id});
    }

    setColorSchema = () => {
        this.forceUpdate(); // redraw to show to new color schema
    }

    /**
     * To open a given card
     * This function takes care of other actions has to be done
     * based on active card and the card going to be opened
     *
     * @param {*} card
     */
    openCard(card, forceUpdate) {
        let activeCard = this.state.activeCard;
        if(activeCard === card && card != CARDS.ATTRIBUTE_EDIT) {
            // Do nothing when request came to open same card again except edit attribute card
            return;
        }
        // Set ATTRIBUTE_LIST as card to open if card is not defined
        card = card || CARDS.ATTRIBUTE_LIST;

        // Set nextCard = card when a card open request is called if active card is not ATTRIBUTE_LIST
        // In this case open ATTRIBUTE_LIST first and then open the requested card
        var nextCard = null;
        if(card != CARDS.ATTRIBUTE_LIST && activeCard != CARDS.ATTRIBUTE_LIST) {
            nextCard = card;
            card = CARDS.ATTRIBUTE_LIST
        }

        // Reset sampling
        if(card != CARDS.SAMPLING && activeCard === CARDS.SAMPLING) {
            this.samplingCardEle.saveAndRemoveSampling();
        }

        // To update the attributes if a user navigates from ATTRIBUTE_EDIT or ATTRIBUTE_ADD
        if(activeCard === CARDS.ATTRIBUTE_EDIT || activeCard === CARDS.ATTRIBUTE_ADD
            || activeCard === CARDS.ATTRIBUTE_SETTINGS || forceUpdate === true) {
            this.setBaseCase();
        }

        let state = {};

        // Focus last focused items on reopning ATTRIBUTE_LIST
        if(card === CARDS.ATTRIBUTE_LIST) {
            let eleToFocus = '';
            if(activeCard === CARDS.ATTRIBUTE_SETTINGS) {
                eleToFocus = "ATTR_DIS";
            } else if(activeCard === CARDS.ATTRIBUTE_EDIT) {
                eleToFocus = "ATTR_ID:" + this.state.editingAttribute.id
            } else if(activeCard === CARDS.ATTRIBUTE_ADD) {
                eleToFocus = "ATTR_NEW";
            }
            state.eleToFocus = eleToFocus;
        }

        // Remove editingAttribute when card/nextCard is not ATTRIBUTE_EDIT
        if(card != CARDS.ATTRIBUTE_EDIT && nextCard != CARDS.ATTRIBUTE_EDIT) {
            state.editingAttribute = undefined;
        }

        /*
        // This is not required anymore
        if(card != CARDS.ATTRIBUTE_LIST && !this.props.isOpen) {
            this.leftToggle(true);
        }
        */

        // To de-highlight f(x) in toolbar
        if((activeCard === CARDS.MODEL_FUNCTIONS || card === CARDS.MODEL_FUNCTIONS) && this.props.onModelFunctionVisibilityChange) {
            this.props.onModelFunctionVisibilityChange(card === CARDS.MODEL_FUNCTIONS);
        }

        // Calling onClosingAttribEdit when ATTRIBUTE_EDIT is closed
        if(card != CARDS.ATTRIBUTE_EDIT && activeCard === CARDS.ATTRIBUTE_EDIT) {
            // Calling AttribEdit close callback
            if(this.props.onClosingAttribEdit) {
                // TODO Pass attrib old and new value
                this.props.onClosingAttribEdit();
            }
        }

        // Opening card
        this.setState({
            activeCard: card,
            ...state
        });

        // opening nextCard if it is available
        if(nextCard) {
            setTimeout(() => {
                this.setState({
                    activeCard: nextCard,
                    ...state
                });
            }, 500);
            // Reset card value for tracking
            card = nextCard;
        }

        //tracking
        if (card === CARDS.ATTRIBUTE_EDIT) {
            _gaq.push(["_trackEvent", "Plot Function", "Click", "AttributeFilter"]);
        }

        if (card === CARDS.ATTRIBUTE_ADD) {
            _gaq.push(["_trackEvent", "Plot Function", "Click", "AddAttribute"]);
        }

        if (card === CARDS.ATTRIBUTE_SETTINGS) {
            _gaq.push(["_trackEvent", "Plot Function", "Click", "AttributeDisplaySetting"]);
        }

        if (card === CARDS.SAMPLING) {
            _gaq.push(["_trackEvent", "Plot Function", "Click", "RandomSample"]);
        }
    }

    setFocus = (args) => {
        if (args && args === 'SUMMARY'){
            this.attributeListComponent.refs.datasetSummary.focus()
        } else {
            this.refs.caseCardComponent.focus();
        }
    }

    render = () => {

        return (
            <div className="tde-fill" ref="caseCardComponent" tabIndex="0" aria-label={CARDS_ARIA_LABEL[this.state.activeCard]}>
                <Transition in={this.state.activeCard === CARDS.ATTRIBUTE_LIST} mountOnEnter={true} unmountOnExit={true} timeout={_transtionDuration}>
                    {state => (
                    <AttributeListComponent
                        style={{
                            ..._defaultStyleForTransition,
                            ..._transitionStylesForAttribList[state]
                        }}
                        Dyn = {this.props.Dyn}
                        ref={attributeListComponent => {this.attributeListComponent = attributeListComponent}}
                        toolsContainer={this.props.toolsContainer}
                        eleToFocus={this.state.eleToFocus}
                        onAddAttrClick={this.props.onAddAttrClick}
                        draggingElementParent={this.props.draggingElementParent}
                        addOrEditAttribute={this.addOrEditAttribute}
                        displaySettingAttribute={this.displaySettingAttribute}
                        onAttributeNameSelected={this.props.onAttributeNameSelected}
                        onOrderByAttributeSelected={this.props.onOrderByAttributeSelected}
                        addRemoveAttributeOnAxis={this.props.addRemoveAttributeOnAxis}
                        mode={this.props.mode}
                        showHeader={this.props.showHeader}
                        attribs={this.state.attribs}
                        onAxisArribsIds={this.state.onAxisArribsIds}
                        selectedAttribID={this.state.selectedAttribID}
                        filteredArribsIds={this.state.filteredArribsIds}
                        leftToggle={this.leftToggle}
                        isOpen={this.props.isOpen}
                        recordIndex={this.state.recordIndex}
                        onAttributeCasesSelected={this.props.onAttributeCasesSelected}
                    />
                    )}
                </Transition>
                <Transition in={this.state.activeCard === CARDS.ATTRIBUTE_EDIT} mountOnEnter={true} unmountOnExit={true} timeout={_transtionDuration}>
                    {state => (
                    <AttributeEditComponent
                        style={{
                            ..._defaultStyleForTransition,
                            ..._transitionStyles[state]
                        }}
                        Dyn = {this.props.Dyn}
                        ref="attributeFilterComponent"
                        attributeId={this.state.editingAttribute && this.state.editingAttribute.id}
                        caseCardScrollTop={0}
                        onClose={this.reinstateCaseCard}
                        onAttributeDataTypeChange={this.props.onAttributeDataTypeChange}
                        onAttributeCaseFilter={this.onAttributeCaseFilter}
                        onAttributeNumericIntervalsUpdated={this.props.onAttributeNumericIntervalsUpdated}
                        onAttributeNumericDecimalsUpdated={this.props.onAttributeNumericDecimalsUpdated}
                        onAttributeSortOrderChange={this.props.onAttributeSortOrderChange}
                        reduceCaseCardWidth = {this.props.reduceCaseCardWidth}/>
                )}
                </Transition>
                <Transition in={this.state.activeCard === CARDS.ATTRIBUTE_ADD} mountOnEnter={true} unmountOnExit={true} timeout={_transtionDuration}>
                    {state => (
                    <NewAttributeComponent
                        style={{
                            ..._defaultStyleForTransition,
                            ..._transitionStyles[state]
                        }}
                        attributeId={''} caseCardScrollTop={0}
                        Dyn = {this.props.Dyn}
                        onClose={this.reinstateCaseCard}
                        reduceCaseCardWidth = {this.props.reduceCaseCardWidth}/>
                )}
                </Transition>
                <Transition in={this.state.activeCard === CARDS.ATTRIBUTE_SETTINGS} mountOnEnter={true} unmountOnExit={true} timeout={_transtionDuration}>
                    {state => (
                    <AttributeDisplaySetting
                        style={{
                            ..._defaultStyleForTransition,
                            ..._transitionStyles[state]
                        }}
                        Dyn = {this.props.Dyn}
                        attribs={this.state.attribs}
                        onClose={this.reinstateCaseCard}
                        onAttributesHidden={this.props.onAttributesHidden}
                        reduceCaseCardWidth = {this.props.reduceCaseCardWidth}/>
                )}
                </Transition>
                <Transition in={this.state.activeCard === CARDS.SAMPLING} mountOnEnter={true} unmountOnExit={true} timeout={_transtionDuration}>
                    {state => (
                    <RandomSampleComponent
                        style={{
                            ..._defaultStyleForTransition,
                            ..._transitionStyles[state]
                        }}
                        ref={ele => this.samplingCardEle = ele}
                        Dyn = {this.props.Dyn}
                        caseCardScrollTop={0}
                        onClose={this.reinstateCaseCard}
                        onApplyRandomSample={this.props.onApplyRandomSample}
                        reduceCaseCardWidth = {this.props.reduceCaseCardWidth}/>
                )}
                </Transition>
                <Transition in={this.state.activeCard === CARDS.MODEL_FUNCTIONS} mountOnEnter={true} unmountOnExit={true} timeout={_transtionDuration}>
                    {state => (
                        <ModelFunctionsWrapper
                            style={{
                                ..._defaultStyleForTransition,
                                ..._transitionStyles[state]
                            }}
                            toolsContainer={this.props.toolsContainer}
                            onClose={this.reinstateCaseCard} Dyn={this.props.Dyn}
                            reduceCaseCardWidth = {this.props.reduceCaseCardWidth}/>
                    )}
                </Transition>
                <Transition in={this.state.activeCard === CARDS.PLOT_SETTINGS} mountOnEnter={true} unmountOnExit={true} timeout={_transtionDuration}>
                    {state => (
                        <PlotSettingComponent
                            style={{
                                ..._defaultStyleForTransition,
                                ..._transitionStyles[state]
                            }}
                         onClose={this.reinstateCaseCard}
                         onAttributeNameSelected={this.props.onAttributeNameSelected}
                         onOrderByAttributeSelected={this.props.onOrderByAttributeSelected}
                         attribs={this.state.attribs}
                         Dyn={this.props.Dyn}
                         mode={this.props.mode}
                         switchLanguage={this.props.switchLanguage}
                         language={this.props.language}
                         switchTheme={this.props.switchTheme}
                         reduceCaseCardWidth = {this.props.reduceCaseCardWidth}/>
                    )}
                </Transition>
                <Transition in={this.state.activeCard === CARDS.ACCESSIBILITY_SETTINGS} mountOnEnter={true} unmountOnExit={true} timeout={_transtionDuration}>
                    {state => (
                        <AccessibilitySettingsComponent
                            style={{
                                ..._defaultStyleForTransition,
                                ..._transitionStyles[state]
                            }}
                         onClose={this.reinstateCaseCard} Dyn={this.props.Dyn} switchLanguage={this.props.switchLanguage} switchTheme={this.props.switchTheme}
                         reduceCaseCardWidth = {this.props.reduceCaseCardWidth}/>
                    )}
                </Transition>
            </div>
        );
    }
}

// To expose the component under Dyn, so that it can be access outside DataExploration Environment
// Dyn.CaseCardComponent = CaseCardComponent;
DynG.CaseCardComponent = CaseCardComponent;

export default CaseCardComponent;
